import angular from 'angular';
import parseStandardField from 'App/resources/parsers/standardField';

angular.module('upResources').service('ParseStandardField', function () {
	return parseStandardField;
});
